import { showToast } from "actions/toastActions";
import { isExist } from "cxa-utils";

export const HDF_LOAD_REQUEST = "HDF_LOAD_REQUEST";
export const HDF_LOAD_SUCCESS = "HDF_LOAD_SUCCESS";
export const HDF_LOAD_FAILURE = "HDF_LOAD_FAILURE";
export const HDF_SAVE_REQUEST = "HDF_SAVE_REQUEST";
export const HDF_SAVE_SUCCESS = "HDF_SAVE_SUCCESS";
export const HDF_SAVE_FAILURE = "HDF_SAVE_FAILURE";

/**
 * Toast action
 * @param  {string} message
 * @return {Object}
 */
const _toastAction = message => showToast({ message });

/**
 * Load HDF
 * @param  {string}   HDFId
 * @param  {boolean?} [isWithMembersWithUWData=false]
 * @return {Function}
 */
export const load = (HDFId, planYearId, enrolmentKey, isWithMembersWithUWData = false) => (
  dispatch,
  getState,
  api
) => {
  dispatch({ type: HDF_LOAD_REQUEST, payload: null });

  // @NOTE 16 October 2018
  // This time Aia is using 'getHdfAndMembersWithUW()'
  const promise = isWithMembersWithUWData
    ? api.getHdfAndMembersWithUW(HDFId, planYearId, enrolmentKey)
    : api.getHdf(HDFId, planYearId, enrolmentKey);

  const _successFn = response => {
    const { body } = response;
    const HDFormIDField = {
      fieldName: "HDFormID",
      fieldValue: HDFId,
      isReadOnly: true,
    };
    const reBody = isWithMembersWithUWData ? [HDFormIDField, ...body.fieldList] : [HDFormIDField];

    dispatch({
      type: HDF_LOAD_SUCCESS,
      payload: {
        hdfData: [...body, ...reBody],
        membersWithUW: isWithMembersWithUWData ? body.membersWithUW : [],
        isWithMembersWithUWData,
      },
    });
  };

  const _failureFn = err => dispatch({ type: HDF_LOAD_FAILURE, payload: err });

  return promise.then(_successFn).catch(_failureFn);
};

/**
 * Save HDF
 * @param  {string}   HDFId
 * @return {Function}
 */
export const save = HDFId => (dispatch, getState, api) => {
  const { form } = getState();
  const values = isExist(form) && form[HDFId].values;

  if ("declaration" in values) {
    values.declaration = values.declaration.toString();
  }

  dispatch({ type: HDF_SAVE_REQUEST, payload: null });

  const promise = api.saveHdf(values);

  const _successFn = response => {
    const { body } = response;

    dispatch({ type: HDF_SAVE_SUCCESS, payload: body });

    if (body) {
      const { message } = body;
      const toastAction = _toastAction(message);

      dispatch(toastAction);
    }
  };

  const _failureFn = err => dispatch({ type: HDF_SAVE_FAILURE, payload: err });

  return promise.then(_successFn).catch(_failureFn);
};

/**
 * Confirm HDF
 * @param  {Object}   data
 * @return {Function}
 */
export const confirm = data => {
  if ("declaration" in data) {
    data.declaration = data.declaration.toString();
  }

  return (dispatch, getState, api) => {
    dispatch({ type: HDF_SAVE_REQUEST, payload: null });

    const promise = api.confirmHdf(data);

    const _successFn = response => {
      const { body } = response;

      dispatch({ type: HDF_SAVE_SUCCESS, payload: body });

      if (body) {
        const toastAction = _toastAction(body.message);

        dispatch(toastAction);
        // Send a message to the parent window
        window.opener.postMessage('HDF_SAVE_SUCCESS', window.location.origin);

        if (body.result) {
          setTimeout(() => window.close(), 5000);
        }
      }
    };

    const _failureFn = err => dispatch({ type: HDF_SAVE_FAILURE, payload: err });

    return promise.then(_successFn).catch(_failureFn);
  };
};



// WEBPACK FOOTER //
// ./actions/hdfActions.js